(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pm-promo-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pm-promo-carousel')){
  customElements.define('pm-promo-carousel',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;this.track=this.querySelector('.pm-promo__track');this.slides=[...this.querySelectorAll('.pm-promo__slide')];this.index=0;this.paused=false;this.hovered=false;
      this.syncHeight=()=>{const slide=this.slides[this.index];if(slide)this.track.style.height=slide.offsetHeight+'px';};this.resizeObserver=new ResizeObserver(()=>this.syncHeight());this.slides.forEach(slide=>this.resizeObserver.observe(slide));this.syncHeight();
      this.abort=new AbortController();const options={signal:this.abort.signal};
      this.querySelector('[data-next]')?.addEventListener('click',()=>this.go(this.index+1),options);
      this.querySelector('[data-prev]')?.addEventListener('click',()=>this.go(this.index-1),options);
      this.querySelector('[data-pause]')?.addEventListener('click',()=>{this.paused=!this.paused;const b=this.querySelector('[data-pause]');b.setAttribute('aria-pressed',String(this.paused));b.textContent=this.paused?b.dataset.playLabel:b.dataset.pauseLabel;},options);
      this.track.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.syncHeight();const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=(this.index+1)+' / '+this.slides.length;},options);
      this.addEventListener('mouseenter',()=>this.hovered=true,options);
      this.addEventListener('mouseleave',()=>this.hovered=false,options);
      this.track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));}},options);
      if(this.dataset.autoplay==='true'&&this.slides.length>1&&!matchMedia('(prefers-reduced-motion: reduce)').matches){
        this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.contains(document.activeElement)&&!document.hidden)this.go(this.index+1);},Number(this.dataset.speed)||7000);
      }
    }
    go(index){this.index=(index+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.track.clientWidth*this.index,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    disconnectedCallback(){clearInterval(this.timer);this.abort?.abort();this.resizeObserver?.disconnect();this.track.style.removeProperty('height');this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
